import Image from 'next/image'

const FULL_LOGO_RATIO = 220 / 52

export function HolmiAppFullLogo({
  height = 32,
  className,
  priority,
}: {
  height?: number
  className?: string
  priority?: boolean
}) {
  const width = Math.round(height * FULL_LOGO_RATIO)
  return (
    <Image
      src="/holmiapp.svg"
      alt="HolmiApp"
      width={width}
      height={height}
      className={className}
      priority={priority}
    />
  )
}

export function HolmiAppMark({
  size = 32,
  className,
  alt = '',
}: {
  size?: number
  className?: string
  alt?: string
}) {
  return (
    <Image
      src="/holmiapp-mark.svg"
      alt={alt}
      width={size}
      height={size}
      className={className}
    />
  )
}

export function HolmiAppDarkFooterBrand({
  brandClassName,
  textClassName,
}: {
  brandClassName?: string
  textClassName?: string
}) {
  return (
    <div className={brandClassName}>
      <HolmiAppMark size={28} />
      <span className={textClassName}>HolmiApp</span>
    </div>
  )
}
